require(
      "!../../node_modules/gatsby-module-loader/patch.js"
    );
    module.exports = function(cb) { return require.ensure([], function(_, error) {
        if (error) {
          console.log('bundle loading error', error)
          cb(true)
        } else {
          cb(null, function() { return require("!!../../node_modules/json-loader/index.js!./blog-cooking-coding-and-career-changes-a-chefs-journey-in-learning-to-code.json") })
        }
      }, "path---blog-cooking-coding-and-career-changes-a-chefs-journey-in-learning-to-code");
     }
    


//////////////////
// WEBPACK FOOTER
// ./~/gatsby-module-loader?name=path---blog-cooking-coding-and-career-changes-a-chefs-journey-in-learning-to-code!./.cache/json/blog-cooking-coding-and-career-changes-a-chefs-journey-in-learning-to-code.json
// module id = 776
// module chunks = 231608221292675